import Http from "@/api/http";

export default {
  index(filter) {
    return Http.get(`/done_approvals`, {
      params: {
        // solution_id: localStorage.getItem("solution_id"),
        ...filter,
      },
    });
  },

  show(id) {
    return Http.get(`/done_approvals/${id}`);
  },

  create(done_approval) {
    return Http.post(`/done_approvals`, {done_approval: {...done_approval}});
  },

  update(done_approval) {
    return Http.put(`/done_approvals/${done_approval.id}`, {done_approval: {...done_approval}});
  },

}